import { render, staticRenderFns } from "./DashboardActionItems.vue?vue&type=template&id=601f676c&scoped=true"
import script from "./DashboardActionItems.vue?vue&type=script&lang=js"
export * from "./DashboardActionItems.vue?vue&type=script&lang=js"
import style0 from "./DashboardActionItems.vue?vue&type=style&index=0&id=601f676c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601f676c",
  null
  
)

export default component.exports